
const state = {
  access_token: '',
  data: {},
  id: null,
  integrable_id: undefined,
  integrable_type: '',
  service_provider: '',
}

export const requiredFields = [
  { key: 'integrable_id' },
  { key: 'integrable_type' },
  { key: 'service_provider' },
]

export default state
